import { Button } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

const SaveButton = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <Button
      loading={disabled}
      color="orange"
      radius={"md"}
      type="submit"
      disabled={disabled}
      className="rounded-md dark:bg-orange-700 !bg-orange px-3 py-2 text-sm font-semibold text-white shadow-sm dark:hover:bg-orange-600 hover:bg-orange-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
    >
      {t("actions.save")}
    </Button>
  );
};

export default SaveButton;
